// extracted by mini-css-extract-plugin
export default {"listItem":"IconDescriptor_listItem__H8TkX"};